<template>
  <div class="section-lottery" :class="{'past': isPast}" v-if="showSection" @click="openLottery">
    <div class="line-1">
      <div class="title-tag">
        <svg
          class="game-controller-icon"
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.39047 7.42149C4.23503 7.42149 4.05996 7.52126 3.85052 7.72724L3.11423 8.49965C2.93697 8.67667 2.49247 9.02264 2.1325 9.02264C1.68255 9.02264 1.32258 8.69276 1.15078 8.53184C0.790326 8.19421 0.810449 7.8426 0.861241 6.9551C0.864919 6.89083 0.868758 6.82375 0.872624 6.75367C0.927165 5.9732 1.12709 4.32757 1.38803 3.92147C1.68255 3.46312 2.18977 2.94792 3.24513 3.00424C3.50733 3.03003 3.62716 3.09243 3.75172 3.1573C3.86034 3.21387 3.97257 3.27231 4.18595 3.30998C4.50501 3.3663 4.6359 3.3663 5.01223 3.3663C5.38856 3.3663 5.51945 3.3663 5.83851 3.30998C6.05189 3.27231 6.16412 3.21387 6.27274 3.1573C6.3973 3.09243 6.51713 3.03003 6.77933 3.00424C7.83469 2.94792 8.34191 3.46312 8.63643 3.92147C8.89737 4.32757 9.0973 5.9732 9.15184 6.75367C9.1557 6.82375 9.15954 6.89083 9.16322 6.9551C9.21401 7.8426 9.23413 8.19422 8.87368 8.53184C8.70188 8.69276 8.34191 9.02264 7.89196 9.02264C7.53199 9.02264 7.08749 8.67667 6.91023 8.49965L6.17394 7.72724C5.96451 7.52126 5.78943 7.42149 5.63399 7.42149H4.39047ZM3.07451 4.354C2.97269 4.354 2.89014 4.43655 2.89014 4.53837V5.12629H2.30815C2.20632 5.12629 2.12378 5.20884 2.12378 5.31066V5.604C2.12378 5.70582 2.20632 5.78837 2.30815 5.78837H2.89014V6.37654C2.89014 6.47837 2.97269 6.56091 3.07451 6.56091H3.36267C3.46449 6.56091 3.54703 6.47837 3.54703 6.37654V5.78837H4.12904C4.23087 5.78837 4.31341 5.70582 4.31341 5.604V5.31066C4.31341 5.20884 4.23087 5.12629 4.12904 5.12629H3.54703V4.53837C3.54703 4.43655 3.46449 4.354 3.36267 4.354H3.07451ZM7.83247 4.82691C7.83247 5.08809 7.6224 5.29982 7.36326 5.29982C7.10413 5.29982 6.89406 5.08809 6.89406 4.82691C6.89406 4.56573 7.10413 4.354 7.36326 4.354C7.6224 4.354 7.83247 4.56573 7.83247 4.82691ZM6.4405 6.38742C6.69963 6.38742 6.90971 6.17569 6.90971 5.91451C6.90971 5.65333 6.69963 5.4416 6.4405 5.4416C6.18136 5.4416 5.97129 5.65333 5.97129 5.91451C5.97129 6.17569 6.18136 6.38742 6.4405 6.38742Z"
            fill="white"
          />
        </svg>
        <span class="tag-name">抽奖</span>
      </div>
      <p>{{ sectionData.award.award_name }}</p>
    </div>
    <div class="line-2">
      <p class="lottery-condition" :class="{lose: is_loser}">{{stateDesc}}</p>
      <p class="time">{{ sectionData.award.award_end_time }} 开奖</p>
    </div>
  </div>
</template>
<script>
import { executeProtocolOutApp } from '_lib/utils'
export default {
  props: {
    linkInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      is_loser: false,
    }
  },
  methods: {
    openLottery () {
      executeProtocolOutApp({
        "protocol_type": "openWindow",
        "full_screen": true,
        "navigation_bar": {
          "title": this.sectionData?.award?.award_name || ' '
        },
        "webview": {
          "url": window.location.origin + '/store/roll_room_v2?award_id=' + this.sectionData?.award?.award_id
        }
      })
    }
  },
  computed: {
    showSection() {
      return this.linkInfo.relate_award_info
    },
    sectionData() {
      console.log('[award]', this.linkInfo.relate_award_info)
      return this.linkInfo.relate_award_info
    },
    isPast () {
      return this.sectionData.award.status != 0 && !this.sectionData.joined
    },
    stateDesc() {
      if (this.sectionData.joined) {
        if (this.sectionData.award.status == 0) {
          return '已成功参与，等待开奖'
        } else {
          if (this.sectionData.award.is_winner) {
            return '恭喜中奖，请等待官方人员联系'
          } else {
            this.is_loser = true
            return '很遗憾，未中奖'
          }
        }
      } else {
        if (this.sectionData.award.status == 0) {
          return this.sectionData.front_tasks.reduce((pre, cur, index) => { 
            if (index) {
              pre += `+${cur.task_name}`
            } else {
              pre += cur.task_name
            }
            return pre
          }, '')
        } else {
          this.is_loser = true
          return '抽奖活动已结束'
        }
      }
    },
  },
}
</script>
<style lang="less">
.section-lottery {
  position: relative;
  padding: 10px;
  border-radius: 8px;
  margin: 8px 12px;
  background: linear-gradient(to right, #ffd9df66, #ffecd966);
  // &::before {
  //   content: '';
  //   box-sizing: border-box;
  //   position: absolute;
  //   top: 0px;
  //   left: 0px;
  //   width: 200%;
  //   height: 200%;
  //   border: 1px solid #ffd9df66;
  //   border-radius: 16px;
  //   transform: scale(0.5);
  //   transform-origin: left top;
  // }
  &.past {
    background: #FAFBFC;
  }
  .line-1 {
    position: relative;
    display: -webkit-box;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    color: #14191e;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    word-wrap: break-word;
    text-overflow: ellipsis;
    text-indent: 45px;
    overflow: hidden;
    .title-tag {
      position: absolute;
      top: 1px;
      left: 0;
      display: flex;
      align-items: center;
      height: 16px;
      padding: 0 5px 0 4px;
      border-radius: 2px;
      text-indent: 0;
      background: linear-gradient(to right, #ff5094, #ff7245);
      .tag-name {
        margin-left: 2px;
        font-weight: 600;
        line-height: 12px;
        font-size: 10px;
        color: #ffffff;
      }
    }
  }
  .line-2 {
    display: flex;
    align-items: center;
    margin-top: 4px;
    line-height: 14px;
    font-size: 10px;
    .lottery-condition {
      flex: 1;
      width: 0;
      color: #ff5976;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.lose {
        color: #8C9196;
      }
    }
    .time {
      flex-shrink: 0;
      color: #c8cdd2;
    }
  }
}
@media only screen and (max-width: 640px) {
  .com-title {
    padding: 10px 12px 0;
  }
}
</style>